import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=1cdfc6f5&scoped=true&"
import script from "./ModalCard.vue?vue&type=script&lang=js&"
export * from "./ModalCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalCard.vue?vue&type=style&index=0&id=1cdfc6f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfc6f5",
  null
  
)

component.options.__file = "ModalCard.vue"
export default component.exports